(() => {
  let pending = false;
  const productButtons = new Map();

  const update = () => {
    pending = false;

    document.querySelectorAll('.js-product-form-main .prod-page-raq-btn-holder').forEach((holder) => {
      const productId = holder.getAttribute('scr-pid');
      if (productId) productButtons.set(productId, holder);
    });

    document.querySelectorAll('.js-product-form-main').forEach((form) => {
      const productId = form.querySelector('input[name="product-id"]')?.value;
      const variantId = form.querySelector('[name="id"]')?.value;
      const target = form.querySelector('.product-info__add-button');
      const holder = productButtons.get(productId);
      if (!holder || !target) return;
      if (!target.contains(holder)) target.append(holder);
      const button = holder.querySelector('.sc-raq-add-to-quote-btn');
      if (button) {
        if (button.type !== 'button') button.type = 'button';
        button.classList.add('btn', 'btn--secondary');
        const label = document.querySelector('quote-drawer')?.dataset.add;
        if (label && button.textContent !== label) button.textContent = label;
      }
      if (variantId) {
        [holder, button].filter(Boolean).forEach((element) => {
          if (element.getAttribute('scr-vid') !== variantId) element.setAttribute('scr-vid', variantId);
        });
      }
    });
    const notification = document.querySelector('#raq-notification-link .raq-notification');
    const parsed = Number.parseInt(notification?.getAttribute('data-badge') || '0', 10);
    const count = Number.isFinite(parsed) && parsed > 0 ? parsed : 0;

    document.querySelectorAll('[data-quote-header-link]').forEach((link) => {
      const badge = link.querySelector('[data-quote-count]');
      const announcement = link.querySelector('[data-quote-announcement]');
      const label = link.dataset.quoteLabel;
      const text = String(count);
      const accessibleLabel = count ? label + ': ' + text : label;

      if (badge.textContent !== text) badge.textContent = text;
      if (badge.hidden !== (count === 0)) badge.hidden = count === 0;
      if (link.getAttribute('aria-label') !== accessibleLabel) {
        link.setAttribute('aria-label', accessibleLabel);
        announcement.textContent = accessibleLabel;
      }
    });
  };

  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };

  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-badge', 'value']
    });
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();